export const generateArrayOfNumbers = (length: number): number[] => [
  ...Array(length).keys(),
]
